import { startImages } from "../../../services/assetsGenerationAPI";

export const handleStartGeneratingImages = async ({
  publicationId,
  token,
  setActiveTasks,
  setTaskStatus,
  setAlert,
  setupWebSocket,
  setOpenImagesDialog,
  setRefreshTrigger = null,
}) => {
  try {
    const uniqueId = "pending";
    setActiveTasks((prev) => {
      const nextArr = [...(prev.images || [])];
      if (!nextArr.includes(uniqueId)) nextArr.push(uniqueId);
      return { ...prev, images: nextArr };
    });
    localStorage.setItem("activeTasks", "true");
    setTaskStatus(prev => ({
      ...prev,
      images: {
        ...(prev.images || {}),
        [uniqueId]: { progress: 0, status: "queued", publicationId: Number(publicationId) }
      }
    }));

    const result = await startImages(publicationId, token);

    if (result.error) {
      setAlert({ severity: "warning", message: result.error });
      setActiveTasks(prev => ({ ...prev, images: (prev.images || []).filter(id => id !== "pending") }));
    } else if (result.task_id) {
      setActiveTasks(prev => ({ ...prev, images: (prev.images || []).filter(id => id !== "pending") }));
      setupWebSocket(result.task_id, "images", publicationId, null, (message, severity) => {
        setAlert({ severity, message });
      });
      setAlert({
        severity: "success",
        message: "Images Generation Started",
      });
      if (setRefreshTrigger) {
        setRefreshTrigger(prev => prev + 1);
      }
      setOpenImagesDialog(false);
    }
  } catch (error) {
    setAlert({
      severity: "warning",
      message: "Failed to start figures generation. Please try again.",
    });
    setActiveTasks(prev => ({ ...prev, images: (prev.images || []).filter(id => id !== "pending") }));
  }
  setOpenImagesDialog(false);
};

export const handleOpenImagesDialog = (setOpenImagesDialog) => {
  setOpenImagesDialog(true);
};

export const handleCloseImagesDialog = (setOpenImagesDialog) => {
  setOpenImagesDialog(false);
};
